var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 33,
    viewBox: "0 0 213 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9619 10.0101C38.734 8.27406 38.4167 5.21244 33.0895 5.21244C29.4451 5.21244 27.6261 6.67483 27.6261 9.00525C27.6261 13.85 35.7307 12.4774 41.2389 15.2674C43.8354 16.5011 45.976 18.5578 45.976 22.5794C45.976 29.6177 40.8768 33 32.9553 33C25.8987 33 20.7057 29.5707 20.5694 22.3955H27.0808C27.0808 25.9147 29.2683 27.6507 33.2301 27.6507C35.9629 27.6507 39.6499 26.9666 39.6499 23.3085C39.6499 18.0062 28.8594 20.5675 23.807 16.0393C22.3032 14.7158 21.1189 12.5672 21.1189 9.45851C21.1189 3.15141 26.7208 -0.00427246 32.868 -0.00427246C39.2431 -0.00427246 44.9345 2.32615 45.435 10.0058H38.9619V10.0101Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0502 6.12324V32.4954H58.7646V6.12324H49.3862V0.502441H74.4286V6.12324H65.0502Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5468 32.4954L85.1105 0.502441H94.2141L104.053 32.4954H97.177L95.3558 26.0964H83.8346L82.1051 32.4954H75.5468ZM89.526 5.34928L85.3363 20.6595H93.8052L89.526 5.34928Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.839 6.12324V32.4954H114.553V6.12324H105.175V0.502441H130.218V6.12324H120.839Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.94 32.4954V0.502441H143.221V32.4954H136.94Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.073 33C156.921 33 150.638 26.9666 150.638 16.546C150.638 6.12536 156.919 0 165.073 0C173.177 0 179.508 6.12323 179.508 16.546C179.508 26.9687 173.175 33 165.073 33ZM165.073 5.5759C160.155 5.5759 157.286 9.41574 157.286 16.546C157.286 23.2636 160.155 27.4241 165.073 27.4241C169.946 27.4241 172.86 23.2636 172.86 16.546C172.858 9.41574 169.944 5.5759 165.073 5.5759Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M205.349 32.4954L193.283 10.0101V32.4954H187.001V0.502441H194.97L206.763 22.806V0.502441H213V32.4954H205.349Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14704 26.9751H10.814V29.4253H2.14704V32.4954H0V23.89H2.14704V26.9751Z",
    fill: "#D66F28"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.814 14.4037H6.50289V18.684H10.814V21.1341H0V18.6818H4.32603V14.4037H0V11.9685H10.814V14.4037Z",
    fill: "#D66F28"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.814 8.46434H0V0.664922H2.14704V6.01419H4.24722V0.897964H6.42408V6.01633H8.67975V0.510986H10.8119V8.46434H10.814Z",
    fill: "#D66F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.8f37a40fe31b373b010d593fd92b6038.svg";
export { ForwardRef as ReactComponent };